import { useTheme, IconButton, Icon, Grid } from '../../../base';
import { TimeToHireChartType } from '../../../common';

interface IChartTypeToggleProps {
    activeType: TimeToHireChartType;
    onChange: (type: TimeToHireChartType) => void;
}

const TOGGLE_ITEMS: { type: TimeToHireChartType; icon: string }[] = [
    { type: TimeToHireChartType.PIE, icon: 'PieChartOutlinedIcon' },
    { type: TimeToHireChartType.LINE, icon: 'ShowChartOutlinedIcon' },
    { type: TimeToHireChartType.BAR, icon: 'BarChartOutlinedIcon' },
];

const ChartTypeToggle = ({
    activeType,
    onChange,
}: IChartTypeToggleProps) => {
    const theme = useTheme();

    return (
        <Grid>
            {TOGGLE_ITEMS.map((item) => {
                const isActive = activeType === item.type;
                return (
                    <IconButton
                        key={item.type}
                        onClick={() => onChange(item.type)}
                        sx={{
                            borderRadius: 1,
                            backgroundColor: 'transparent',
                            color: isActive
                                ? theme.palette.secondary.main
                                : theme.palette.grey[400],
                            '&:hover': {
                                backgroundColor: 'transparent',
                                color: isActive
                                    ? theme.palette.secondary.dark
                                    : theme.palette.grey[600],
                            },
                        }}
                        size="small"
                    >
                        <Icon name={item.icon} size={23} />
                    </IconButton>
                );
            })}
        </Grid>
    );
};

export default ChartTypeToggle;
